import React from "react"
import "./style.css"

/**
 * @param {Object} props
 * @param {boolean} props.isOpen
 * @param {function} props.onClose
 * @param {string} props.title
 * @param {string} props.mainText
 * @param {Array<string>} [props.requirements]
 * @param {string} [props.footerText]
 * @param {string} [props.buttonText="Entendi, continuar"]
 * @param {string} [props.requirementsTitle="Requisitos:"]
 * @param {string} [props.className]
 * @param {string} [props.contentClassName]
 */
const AlertPopup = ({
  isOpen,
  onClose,
  title,
  mainText,
  requirements = [],
  footerText,
  buttonText = "Entendi, continuar",
  requirementsTitle = "Requisitos:",
  className = "alert-overlay",
  contentClassName = "alert-content",
  closeClassName = "alert-close",
  bodyClassName = "alert-body",
  titleClassName = "alert-title",
  textClassName = "alert-text",
  requirementsClassName = "alert-requirements",
  subtitleClassName = "alert-subtitle",
  listClassName = "alert-list",
  footerClassName = "alert-footer",
  buttonClassName = "alert-button",
}) => {
  if (!isOpen) return null

  return (
    <div className={className}>
      <div className={contentClassName}>
        <button className={closeClassName} onClick={onClose}>
          ✕
        </button>

        <div className={bodyClassName}>
          <h2 className={titleClassName}>{title}</h2>

          <p className={textClassName}>{mainText}</p>

          {requirements.length > 0 && (
            <div className={requirementsClassName}>
              <p className={subtitleClassName}>{requirementsTitle}</p>
              <ul className={listClassName}>
                {requirements.map((requirement, index) => (
                  <li key={index}>
                    <strong>✓</strong> {requirement}
                  </li>
                ))}
              </ul>
            </div>
          )}

          {footerText && <p className={footerClassName}>{footerText}</p>}
        </div>

        <button className={buttonClassName} onClick={onClose}>
          {buttonText}
        </button>
      </div>
    </div>
  )
}

export default AlertPopup
